export default () => {
  return {
    businessName: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '业务区是必填的',
          trigger: 'blur'
        }
      }
    },
    projectName: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '项目名称是必填的',
          trigger: 'blur'
        }
      }
    },
    businessType: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '业务类型是必填的',
          trigger: 'blur'
        }
      }
    },
    progressStatus: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '进度状态是必填的',
          trigger: 'blur'
        }
      }
    },
    budget: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'number',
          required: true,
          message: '预算是必填的',
          trigger: 'blur'
        }
      }
    },
    projectManagerA: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '项目经理A必填的',
          trigger: 'blur'
        }
      }
    },
    integrators: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '集成商是必填的',
          trigger: 'blur'
        }
      }
    },
    projectType: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '项目类型是必填的',
          trigger: 'blur'
        }
      }
    },
    startDate: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '启动时间必填的',
          trigger: 'blur'
        }
      }
    },
    reachExpect: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '达产预期必填的',
          trigger: 'blur'
        }
      }
    },
    nextAction: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '下步动作是必填的',
          trigger: 'blur'
        }
      }
    },
    nextDeadline: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '下步期限是必填的',
          trigger: 'blur'
        }
      }
    },
    clientManager: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '客户经理是必填的',
          trigger: 'blur'
        }
      }
    },
    jobsDescription: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '支撑工作描述（加时间点）是必填的',
          trigger: 'blur'
        }
      }
    },
    projectDescription: {
      type: 'object',
      required: true,
      fields: {
        value: {
          type: 'string',
          required: true,
          message: '项目描述是必填的',
          trigger: 'blur'
        }
      }
    }
  };
};
